export const SET_PERMISSIONS_FOR_USER = "set-permissions-for-user";
export const REMOVE_USER = "remove-user";
export const FETCH_NEXT_PAGE = "fetch-next-page";
export const FETCH_INITIAL_PAGE = "fetch-initial-page";
